import {
  InputButton,
  TextInput,
  TextInputProps,
} from '@infotech-soe/erp-ui-kit';
import React, { JSX, useState } from 'react';
import { defineMessages, useIntl } from 'react-intl';

import LoginFormField from './LoginFormField';

const messages = defineMessages({
  hide: { id: 'core.loginForm.hidePassword', defaultMessage: 'Hide' },
  show: { id: 'core.loginForm.showPassword', defaultMessage: 'Show' },
});

export const PasswordInput = ({
  label,
  ...rest
}: TextInputProps & { label: string }): JSX.Element => {
  const { formatMessage } = useIntl();
  const [open, setOpen] = useState(false);

  return (
    <LoginFormField label={label}>
      <TextInput
        {...rest}
        type={open ? 'text' : 'password'}
        endSlot={
          <InputButton
            icon={open ? 'eye-off' : 'eye'}
            title={formatMessage(open ? messages.hide : messages.show)}
            onClick={() => setOpen(o => !o)}
          />
        }
      />
    </LoginFormField>
  );
};
